export const API_PATHS = {
  GET_USER_DETAILS: '/ioi/auth/profile',
  GET_ALL_COURSES: '/ioi/public/courses',
  GET_REGISTRATION_DETAILS: '/ioi/application/get-user-application',
  UPDATE_REGISTRATION_DETAILS: '/ioi/application/register',
  APPLY_COUPON: '/ioi/application/apply-coupon',
  LEAD_CAPTURE: '/ioi/application/save-lead/explore',
  INITIATE_PAYMENT: '/ioi/application/initiate-payment',
  VERIFY_PAYMENT: '/ioi/application/verify-payment',
  UPLOAD_S3_SIGNED_URL: '/v3/admin/files/s3-signed-url',
  UPLOAD_FILE: '/ioi/files/upload-updated',
  V1_FILES: '/v1/files',
  IS_ELIGIBLE_FOR_DIRECT_ADMISSION: '/ioi/application/get-user-direct-entry-eligibility',
  GET_EXAM_SCHEDULE_DATES: '/ioi/public/application/get-exam-schedules',
  RE_REGISTER: '/ioi/application/re-register/{applicationId}',
  DOWNLOAD_FEE_STRUCTURE: '/ioi/application/download-fee-structure',
  GET_ADMISSION_FEE: '/ioi/application/get-admission-fee',
  TRACK_SHIFT: '/ioi/application/track-shift',
  VERIFY_GOOGLE_SSO_EMAIL: '/ioi/application/verify-google-sso-email',
};

export const API_CACHE_KEYS = {
  GET_USER_DETAILS: 'get_user_details',
  GET_ALL_COURSES: 'get_all_courses',
  GET_REGISTRATION_DETAILS: 'get_registration_details',
  UPDATE_REGISTRATION_DETAILS: 'update_registration_details',
  APPLY_COUPON: 'apply_coupon',
  LEAD_CAPTURE: 'lead_capture',
  INITIATE_PAYMENT: 'initiate_payment',
  VERIFY_PAYMENT: 'verify_payment',
  UPLOAD_S3_SIGNED_URL: 'upload_s3_signed_url',
  UPLOAD_FILE: 'upload_file',
  IS_ELIGIBLE_FOR_DIRECT_ADMISSION: 'is_eligible_for_direct_admission',
  GET_EXAM_SCHEDULE_DATES: 'get_exam_dates',
  RE_REGISTER: 're_register',
  DOWNLOAD_FEE_STRUCTURE: 'download_fee_structure',
  GET_ADMISSION_FEE: 'get_admission_fee',
  TRACK_SHIFT: 'track_shift',
  VERIFY_GOOGLE_SSO_EMAIL: 'verify_google_sso_email',
};

export const PATTERN = {
  name: '^[A-Za-z ]{2,}$',
  email: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
  phone: '^[6-9]{1}[0-9]{9}$',
  percentage: '^(100(\\.0{1,2})?|([0-9]{1,2})(\\.[0-9]{1,2})?)$',
  maskedPhone: '[X*x]',
  leadingPlus: '^\\+',
  nonDigit: '\\D',
  base64UrlDash: '-',
  base64UrlUnderscore: '_',
};

export const SOT_SYLLABUS =
  'https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/32140a20-06e1-4bf4-b42e-16871fdfd058.pdf';

export const DA_SYLLABUS =
  'https://d3a6pe8ygpgu8u.cloudfront.net/5eb393ee95fab7468a79d189/ADMIN/be71763e-333e-44bd-ac92-da0b59c0871e.pdf';

export const SOM_SYLLABUS =
  'https://static.pw.live/5eb393ee95fab7468a79d189/fad3ee3d-619a-4134-92eb-91c13900a9d0.pdf';

export const COUNSELLER_PHONE_NUMBER = '7428096971';
